<script>
    import "carbon-components-svelte/css/white.css";

    import { yardMarkers, quoteSelectedMaterial, yardPriceMarkers, yards } from '../../../stores.js';
	import { fetchYards, filterYards } from '../../../data.js'

    import { beforeUpdate } from 'svelte';
    import { Dropdown } from "carbon-components-svelte";
    import { yardMaterials } from '../../../data.js'
	import { createEventDispatcher } from 'svelte'

    import YardMapMarker from "../YardMapMarker.svelte"
    import YardPriceMarker from "../YardPriceMarker.svelte"
    import YardDeatils from "../../../forms/Yard/YardDeatils.svelte" 
    import CompanyForm from '../../../forms/Company/CompanyForm.svelte';
    import { removeLines } from "../distance.js";
    import { clearYardPriceMarkers, clearTripCalculations } from './clearMap';

    export let map

    let showYardDetails = false;
    let showYardCompany = false;
    let yardId = null;
    let yard=null;
    let yardCompany = {};
    let selectedId = 0
    const dispatch = createEventDispatcher()
    let items = [{id: "0", text: "All"}];
    
    let promiseQuotes = fetchYards();

    beforeUpdate(async () => {
        items = [{id: "0", text: "All"}];
        let counter = 1;
        yardMaterials.forEach(element => {
            items.push({id: counter.toString(), text: element});
            counter++;
        }) 
    });

    function onFilterYards(e) {
        clearTripCalculations()
        clearYardPriceMarkers()
        // remove all existing yard markers on map
        for (var i = $yardMarkers.length - 1; i >= 0; i--) {
            $yardMarkers[i].marker.remove();
        }
        $yardMarkers = [];
        
        removeLines(map)

        // get the selected material and filter markers
        let selectedMaterialId = e.detail.selectedItem.id;
        if (selectedMaterialId != 0) {
            promiseQuotes = filterYards(e.detail.selectedItem.text);
        } else {
            promiseQuotes = fetchYards();
        }
        
        $quoteSelectedMaterial = e.detail.selectedItem.text
    }

    function clickShowYardDetails(yard) {
        yardId = yard.id
        showYardDetails = true;
    }

    function resetShowYardDetails() {
        // to trigger the {#if showYardDetails} I need to 
        // reset this to false so when then above clickShowYardDetails()
        // is called it will trigger the #if
        showYardDetails=false
    }

    function setShowYardCompany(e) {
        yardCompany = e.detail;
        showYardCompany = !showYardCompany;
    }

    function saveCompanyDetails() {
        yard.company = yardCompany;
        showYardCompany = !showYardCompany;
    }

    function callYarListUpdatedDispatch(result) {
        $yards = result
        dispatch('yards-list-updated')
    }

</script>

{#await promiseQuotes}
<p>loading data</p>
{:then result}
    <div style="display: none;">
        {callYarListUpdatedDispatch(result)}
    </div>
    {#if map}
        <slot />
        {#each result as yard}
            <YardMapMarker yard={yard} on:yard-clicked={() => clickShowYardDetails(yard)}/>
            {#if $quoteSelectedMaterial != "All" }
                <YardPriceMarker yard={yard} selectedMaterial={$quoteSelectedMaterial}/>
            {/if}
        {/each}
    {/if}
{/await}

{#if showYardDetails}
    <YardDeatils yardId={yardId} bind:yard={yard} on:close={resetShowYardDetails} on:edit-company={(e)=>setShowYardCompany(e)}/>
{/if}

{#if showYardCompany}
    <CompanyForm bind:company={yardCompany} on:company-saved={saveCompanyDetails}/>
{/if}

<div class="filter-row">
    <div class="filter-field grow">
        <Dropdown
            light
            titleText="Material Type"
            selectedId="0"
            items={items}
            on:select={(e)=>onFilterYards(e)}
        />
    </div>
    <div class="filter-field action-field">
        <slot name="action" />
    </div>
</div>

<style>
    .filter-row {
        display: grid;
        grid-template-columns: 1fr 150px;
        gap: 12px;
        width: 100%;
        align-items: end;
    }

    .filter-field {
        width: 100%;
    }

    .filter-field.grow {
        flex: 1;
    }

    .action-field {
        display: flex;
        align-items: flex-end;
    }
</style>